/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_FailedInputs */

const en_settings_apikeys_failed = /** @type {(inputs: Settings_Apikeys_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to create key`)
};

const zh_settings_apikeys_failed = /** @type {(inputs: Settings_Apikeys_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建密钥失败`)
};

/**
* | output |
* | --- |
* | "Failed to create key" |
*
* @param {Settings_Apikeys_FailedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_failed = /** @type {((inputs?: Settings_Apikeys_FailedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_FailedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_apikeys_failed(inputs)
	return zh_settings_apikeys_failed(inputs)
});
export { settings_apikeys_failed as "settings.apikeys.failed" }